import { useState } from "react";
import Background from "./Background";
import Footer from "./Footer";
import "./Imprint.css";

function Imprint() {
  const [language, setLanguage] = useState("en");

  return (
    <>
      <Background />
      <Footer />
      <div
        style={{
          position: "absolute",
          backgroundColor: "rgba(0,0,0,0.5)",
          height: "40px",
          width: "80px",
          right: "80px",
          top: "50px",
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <span
          className="imprint-language-button"
          style={{
            color: "white",
            textShadow: "0px 0px 5px purple",
            fontSize: "22px",
            zIndex: "100",
          }}
          onClick={() => setLanguage("en")}
        >
          EN
        </span>
        <div style={{ border: "1px solid white", height: "80%" }}></div>
        <span
          className="imprint-language-button"
          style={{
            color: "white",
            textShadow: "0px 0px 5px purple",
            fontSize: "22px",
            zIndex: "100",
          }}
          onClick={() => setLanguage("de")}
        >
          DE
        </span>
      </div>
      <div className="imprint">
        {language != "en" ? (
          <div className="content">
            <h1>Impressum</h1>
            <br />
            <p>Norman Azar</p>
            <p>GliaTech</p>
            <p> Großgartacherstr. 90</p>
            <p> 74080 Heilbronn</p>
            <p> Deutschland</p>
            <br />
            <p>Tel.: +491792235717 </p>
            <p>E-Mail: admin@gliatech.net</p>
            <br />
            <p> Umsatzsteuer-Identifikationsnummer: DE452413545</p>
            <br />
            <p>
              {" "}
              Plattform der EU-Kommission zur Online-Streitbeilegung:{" "}
              <a href="https://ec.europa.eu/odr">https://ec.europa.eu/odr </a>
            </p>
            <br />
            <p>
              Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor
              einer
              <p>
                Verbraucherschlichtungsstelle weder verpflichtet noch bereit.
              </p>{" "}
            </p>
          </div>
        ) : (
          <div className="content">
            <h1>Imprint</h1>
            <br />
            <p>Norman Azar</p>
            <p>GliaTech</p>
            <p>Großgartacherstr. 90</p>
            <p>74080 Heilbronn</p>
            <p>Germany</p>
            <br />
            <p>Phone: +491792235717</p>
            <p>Email: admin@gliatech.net</p>
            <br />
            <p>VAT Identification Number: DE452413545</p>
            <br />
            <p>
              EU platform for online dispute resolution:
              <a href="https://ec.europa.eu/odr">https://ec.europa.eu/odr</a>
            </p>
            <br />
            <p>
              We are neither obligated nor willing to participate in dispute
              resolution proceedings before a consumer arbitration board.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default Imprint;
